// extracted by mini-css-extract-plugin
module.exports = {"vocCardWrap":"HBscx","dottedLine":"jLwL3","toiGameCapsule":"J6fBc","iconToiGames":"HSwY7","mobileScroll":"uq1Ax","topTitle":"I7KO8","exploreLink":"J07Hc"};